import React from "react";
import { accountAvatarUrl, accountInitials } from "@/lib/accountIdentity";

export const AccountAvatar = ({ user, size = "md" }) => {
  const [broken, setBroken] = React.useState(false);
  const src = accountAvatarUrl(user);
  const dimensions = size === "sm" ? "h-9 w-9" : "h-10 w-10";
  React.useEffect(() => setBroken(false), [src]);
  return (
    <span
      className={`${dimensions} shrink-0 overflow-hidden rounded-full ring-2 ring-white shadow-sm`}
      data-testid="cc-user-avatar"
    >
      {src && !broken ? (
        <img
          src={src}
          alt=""
          className="h-full w-full object-cover"
          onError={() => setBroken(true)}
          data-testid="cc-user-avatar-img"
        />
      ) : (
        <span
          className="flex h-full w-full items-center justify-center bg-[#1E6DE5] text-xs font-bold text-white"
          data-testid="cc-user-avatar-fallback"
        >
          {accountInitials(user)}
        </span>
      )}
    </span>
  );
};